import { useEffect, useRef } from "react";
import { formatIDR } from "../../../../utils/helpers/formatIDR";
import TablerIcon from "../TablerIcon";

const TransactionSuccessFeedback = ({ feedback, onComplete }) => {
  const onCompleteRef = useRef(onComplete);

  useEffect(() => {
    onCompleteRef.current = onComplete;
  }, [onComplete]);

  useEffect(() => {
    if (!feedback?.id) return undefined;

    const timeout = window.setTimeout(() => {
      onCompleteRef.current?.();
    }, 1700);

    return () => window.clearTimeout(timeout);
  }, [feedback?.id]);

  if (!feedback) return null;

  return (
    <div className="pos-success-feedback-layer" role="status" aria-live="polite">
      <div
        key={feedback.id}
        className="pos-success-feedback"
        data-testid="transaction-success-feedback"
        onAnimationEnd={(event) => {
          if (event.target === event.currentTarget) {
            onComplete?.();
          }
        }}>
        <span className="pos-success-feedback-icon">
          <TablerIcon name="check" size={28} />
        </span>
        <span className="pos-success-feedback-copy">
          <strong>{feedback.title || "Transaksi berhasil"}</strong>
          <small data-testid="transaction-success-summary">
            {formatIDR(feedback.total || 0)} · {feedback.paymentLabel || "Pembayaran"}
          </small>
        </span>
      </div>
    </div>
  );
};

export default TransactionSuccessFeedback;
